// extracted by mini-css-extract-plugin
module.exports = {"title":"Settings_title__3_1To","subtitle":"Settings_subtitle__27Cj5","grid":"Settings_grid__ObYhw","gridLabel":"Settings_gridLabel__2znkw","gridValue":"Settings_gridValue__2SCOE"};